import { makeStyles, tokens, shorthands } from '@fluentui/react-components';
import { fontScale } from '@/theme/scalingTokens';

export const useRoomHealthKpiCardsStyles = makeStyles({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: tokens.spacingHorizontalL,
  },
  card: {
    backgroundColor: tokens.colorNeutralBackground1,
    border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
    ...shorthands.borderRadius(tokens.borderRadiusLarge),
    ...shorthands.padding(tokens.spacingVerticalL, tokens.spacingHorizontalL),
    display: 'flex',
    flexDirection: 'column',
    minWidth: 0,
    borderLeftWidth: '4px',
    borderLeftStyle: 'solid',
  },
  accentAmber: { borderLeftColor: tokens.colorPaletteMarigoldForeground2 },
  accentGreen: { borderLeftColor: tokens.colorPaletteGreenForeground1 },
  accentRed: { borderLeftColor: tokens.colorPaletteRedForeground1 },
  value: {
    fontSize: fontScale.subheading,
    fontWeight: tokens.fontWeightBold,
    lineHeight: '1.3',
  },
  valueAmber: { color: tokens.colorPaletteMarigoldForeground2 },
  valueGreen: { color: tokens.colorPaletteGreenForeground1 },
  valueRed: { color: tokens.colorPaletteRedForeground1 },
  label: {
    fontSize: fontScale.subtitle,
    fontWeight: tokens.fontWeightSemibold,
    color: tokens.colorNeutralForeground1,
    marginTop: tokens.spacingVerticalXS,
  },
  subtitle: {
    fontSize: fontScale.caption,
    color: tokens.colorNeutralForeground3,
    marginTop: tokens.spacingVerticalXXS,
  },
});
